module.exports = __webpack_public_path__ + "img/workflow_7.bd3d6bcc.jpg";